import { render } from "./Recordatorios-App.vue?vue&type=template&id=6384f3ec&scoped=true"
import script from "./Recordatorios-App.vue?vue&type=script&lang=js"
export * from "./Recordatorios-App.vue?vue&type=script&lang=js"

import "./Recordatorios-App.vue?vue&type=style&index=0&id=6384f3ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6384f3ec"]])

export default __exports__